module.exports = __webpack_public_path__ + "img/fish_clownfish.3292199b.png";